import React from "react";
import { Outlet } from "react-router-dom";
import MetaLinks from "./components/MetaLinks";
import NavBar from "./layouts/NavBar";
// import FooterSection from "./layouts/FooterSection";
import Sidebar from "./components/Sidebar";

const Layout = () => {
	return (
		<>
			<MetaLinks />
			<NavBar />
			<div className="flex pt-16 overflow-hidden bg-gray-50 dark:bg-gray-900">
				<Sidebar />
				<div
					className="fixed inset-0 z-10 hidden bg-gray-900/50 dark:bg-gray-900/90"
					id="sidebarBackdrop"
				/>
				<div
					id="main-content"
					className="relative w-full h-full overflow-y-auto bg-gray-50 lg:ml-64 dark:bg-gray-900"
				>
					<main>
						<div className="px-4 py-6">
							<Outlet />{" "}
							{/* This is where child routes will be rendered */}
						</div>
					</main>
					{/* <FooterSection /> */}
				</div>
			</div>
		</>
	);
};

export default Layout;
